import { useEffect, useRef, useState } from 'react';

import {
    ref,
    onValue,
    onChildAdded,
    onChildRemoved,
    onDisconnect,
    set,
    get,
} from 'firebase/database';
import {
 
  FaEyeSlash,
 
} from "react-icons/fa";

export const useUserConnections = (userConnectionsNodeUrl, visitorId, database) => {
    const [connectionsList, setConnectionsList] = useState([]);
    const deletedConnectionIdRef = useRef(null);

    useEffect(() => {
        if (!visitorId || !database) return;

        const alertView = window.globalAlertView || {};
        const connectionsRef = ref(database, userConnectionsNodeUrl);

        // Initial fetch
        get(connectionsRef).then((snapshot) => {
            const initialConnections = [];
            snapshot.forEach((child) => {
                initialConnections.push({ id: child.key });
            });
            setConnectionsList(initialConnections);
        });

        // Listen for new connections
        const childAddedUnsub = onChildAdded(connectionsRef, (snapshot) => {
            setConnectionsList((prev) => {
                const exists = prev.some((conn) => conn.id === snapshot.key);
                if (!exists && snapshot.key !== deletedConnectionIdRef.current) {
                    const updated = [...prev, { id: snapshot.key }];
                    if (updated.length > 1) {
                        const msg = updated.length.toString();
                        toast(` ${msg} others are viewing this property.`, {


                            className: 'black-toast',
                            position: 'bottom-right',
                            icon: <FaEyeSlash size={20}/>
                        });

                    }
                    return updated;
                }
                return prev;
            });
        }, (error) => {
            alertView.notificationError?.({
                error,
                viewObject: this,
                databaseUrl: userConnectionsNodeUrl,
                event: 'child_added'
            });
        });

        // Listen for disconnections
        const childRemovedUnsub = onChildRemoved(connectionsRef, (snapshot) => {
            deletedConnectionIdRef.current = snapshot.key;
            setConnectionsList((prev) => prev.filter((conn) => conn.id !== snapshot.key));
        }, (error) => {
            alertView.notificationError?.({
                error,
                viewObject: this,
                databaseUrl: userConnectionsNodeUrl,
                event: 'child_removed'
            });
        });

        // Handle presence
        const presenceRef = ref(database, '.info/connected');
        const presenceUnsub = onValue(presenceRef, (snap) => {
            if (snap.val()) {
                const userRef = ref(database, `${userConnectionsNodeUrl}/${visitorId}`);
                onDisconnect(userRef).remove();
                set(userRef, true);
            }
        });

        // Cleanup
        return () => {
            childAddedUnsub();
            childRemovedUnsub();
            presenceUnsub();
        };
    }, [userConnectionsNodeUrl, visitorId]);
};
